const colors = {
  red: {
    500: '#C4040B',
  },
  green: {
    50: '#F0FBF2',
    500: '#28A037'
  },
  text: {
    main: '#041A1C',
    colored: '#245054',
  },
  success: {
    50: '#EBF4EC',
    100: '#D7EAD9',
    500: '#2D7738',
  },
  warning: {
    50: '#FDF0E3',
    100: '#FAE2C7',
    500: '#AE5700'
  },
  primary: {
    light: '#52B0BA',
    main: '#439098',
    dark: '#245054',
    darker: '#153032',
  },
  secondary: {
    light: '#713EC1',
    main: '#4E2B85',
    dark: '#40226D',
    darker: '#311B54',
  },
  additional: {
    primary: {
      light: {
        default: '#F0FCFC',
        hover: '#B8ECF1',
        active: '#9DE5EB',
      },
      dark: {
        default: '#00A2AE',
        hover: '#008E96',
        active: '#007A7F',
        disabled: '#B8ECF1',
      },
    },
  },
  grey: {
    dark: '#6c6c6c',
    light: '#e0e0e0',
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
  },
  critical: {
    50: '#fbcdd1',
    100: '#f79997',
    200: '#f0716e',
    300: '#d21c1b',
    400: '#c4040b',
    500: '#9d1615',
  },
};

export default colors;
